import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ActivityModule } from '../activity/activity.module';

import { InMeetingAllocationComponent } from '../in-meeting-allocation/in-meeting-allocation';
import { CaptureAllocationOrderComponent } from '../capture-allocation-order/capture-allocation-order';
import { CustomerAllocationList } from './customer-allocation-list/customer-allocation-list';
import { AllocationOrdersList } from './allocation-orders-list/allocation-orders-list';
import { AdjustmentsListComponent } from './adjustments-list/adjustments-list.component';
import { UserInventoryListComponent } from './user-inventory-list/user-inventory-list';
import { ReconciliationListComponent } from './reconciliation-list/reconciliation-list.component';
import { NewSampleDeliveryRequestComponent } from './delivery-request-new/new-sample-delivery-request.component';
import { SampleDeliveryRequestDetailComponent } from './delivery-request-detail/sample-delivery-request-detail.component';
// SdrNotesSectionComponent is now declared+exported by ActivityModule (imported
// below), so the SDR components here still resolve <sdr-notes-section>. It moved
// there so the inline SDR editor + meeting pane (both in ActivityModule) can use
// it without an ActivityModule -> SampleModule import cycle. (OMNI-61002)

const SAMPLE_DECLARATIONS = [
  InMeetingAllocationComponent,
  CaptureAllocationOrderComponent,
  CustomerAllocationList,
  AllocationOrdersList,
  AdjustmentsListComponent,
  UserInventoryListComponent,
  ReconciliationListComponent,
  NewSampleDeliveryRequestComponent,
  SampleDeliveryRequestDetailComponent,
];

@NgModule({
  imports: [SharedModule, ActivityModule],
  declarations: SAMPLE_DECLARATIONS,
  exports: SAMPLE_DECLARATIONS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SampleModule {}
